import React from 'react';
import MobileHeader from '../Shared/MobileHeader';
import styled from '@emotion/styled';
import VideoPlayerPreview from '../Shared/VideoPlayerPreview';
import { PreviewProps } from '../../LandingPagePreview';
import UserProfile from '../Shared/UserProfile';
import EmbedPreviews from '../Shared/EmbedPreviews';
import MessageContent from '../Shared/MessageContent';
import { BonjoroBadgeMobile } from '~/App/Components/BonjoroBadgeMobile';
import LayoutPreview from '../Components/LayoutPreview';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
`;

const Body = styled.div`
  position: relative;
  max-height: 480px;
  overflow: auto;
  padding-top: 5px;
  flex: 1;

  scrollbar-width: thin;
  scrollbar-color: #CDCDCD #f8f8f8;

  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: #f8f8f8;
  }
  ::-webkit-scrollbar-thumb {
    background: #CDCDCD;
    border-radius: 20px;
    border 3px solid #f8f8f8;
  }
`;

const MessageWrapper = styled.div`
  margin: 0 13px;
`;

const VideoPlayerPreviewWrapper = styled.div`
  position: relative;
  height: 150px;
`;

const StyledEmbedsPreview = styled(EmbedPreviews)`
  padding: 15px;
`;

const Title = styled.span`
  display: block;
  font-size: 12px;
`;

const SubTitle = styled.span`
  display: block;
  font-size: 10px;
`;

const NextGen = (props: PreviewProps) => {
  const {
    userName,
    playerImage,
    userImage,
    userShortName,
    message,
    highlight,
    ctaText,
    secondaryColor,
    ctaUrl,
    showCta,
    color,
    embeds,
    showBonjoroBadge,
  } = props;

  return (
    <Wrapper>
      <MobileHeader>
        <Title>{userName} sent you a message</Title>
        <SubTitle>bonjoro.com</SubTitle>
      </MobileHeader>
      <Body>
        <VideoPlayerPreviewWrapper>
          {showBonjoroBadge && (
            <BonjoroBadgeMobile
              className='absolute top-0 left-0 z-[105]'
              cssStyle={{
                zoom: '0.6',
              }}
            />
          )}
          <VideoPlayerPreview playerImage={playerImage || ''} mode='contain' />
        </VideoPlayerPreviewWrapper>
        <UserProfile
          shadowed
          showSocialShare
          userImage={userImage}
          userName={userName}
        />
        <MessageWrapper>
          <MessageContent
            userShortName={userShortName}
            message={message}
            highlight={highlight}
            ctaText={ctaText}
            secondaryColor={secondaryColor}
            ctaUrl={ctaUrl}
            showCta={showCta}
            color={color}
          />
        </MessageWrapper>
        {embeds && embeds.size > 0 && <StyledEmbedsPreview embeds={embeds} />}
      </Body>
      <LayoutPreview />
    </Wrapper>
  );
};

export default NextGen;
